import { ReactNode } from "react";

const ProfileContainer = ({
  children,
  title,
  topRightContent,
}: {
  children: ReactNode;
  title?: string;
  topRightContent?: ReactNode;
}) => {
  return (
    <div className="flex flex-col gap-6 border rounded-lg p-6 text-sm">
      {(topRightContent || title) && (
        <div className="flex items-center justify-between">
          {title && <div className="flex-1 tf-header-base-dark">{title}</div>}
          {topRightContent}
        </div>
      )}
      {children}
    </div>
  );
};

export default ProfileContainer;
